import { useLayoutContext } from '../../../Context/Layout.context';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { updatePdf } from '../../../services/supportPdf/supportPdf.service';
import { IPdfListItem } from '../../../services/supportPdf/supportPdf.types';
import { PdfEditor } from '../PdfEditor/PdfEditor.component';

interface EditPdfProps {
  onClose: () => void;
  onChange: () => void;
  pdfProp: IPdfListItem;
}

export const EditPdf: React.FC<EditPdfProps> = ({ onClose, onChange, pdfProp: pdfProp }) => {
  const handleClose = () => {
    onClose();
  };

  const { openAlert } = useLayoutContext();
  useDocumentTitle('Edytuj pdf');

  const handleEditPdf = (newTitle: string, file: File, id: string) => {
    updatePdf(newTitle, file, id).then(
      () => {
        openAlert('success');
        onChange();
        onClose();
      },
      () => {
        openAlert('save_error');
      },
    );
  };

  return (
    <PdfEditor
      title="Edytuj instrukcję"
      onCancel={handleClose}
      onSave={handleEditPdf}
      onChange={onChange}
      titlePdf={pdfProp.title}
      sizePdf={pdfProp.size}
      pdfId={pdfProp.id}
      file={pdfProp.file}
      path={pdfProp.path}
      fileName={pdfProp.fileName}
    />
  );
};
